import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_ROUTES } from '../constants/app-routes.const';

/**
 * `/main/dashboard?openSession=<id>` used to open a past call in a dialog over Home. Calls have a page
 * of their own now, and the links already out there (Lizzie's stored citations) land on it instead.
 * Redirecting before Home loads keeps Home off the back stack, so the call's back link leads to where
 * the rep really was rather than to a Home that would send them straight back to the call.
 */
export const openSessionRedirectGuard: CanActivateFn = route => {
  const sessionId = route.queryParamMap.get('openSession');
  return sessionId ? inject(Router).createUrlTree([APP_ROUTES.CALLS, sessionId]) : true;
};
